export { type I18nOptions } from 'vue-i18n';

import { createI18n } from '@bv/i18n';

export * from '@bv/i18n';

const i18n = createI18n({});

export default i18n;
